import FileSaver from "file-saver";
import JSZip from "jszip";
import moment from "moment";
import pdf from "pdfmake/build/pdfmake.min";
import pdfFonts from "pdfmake/build/vfs_fonts";
import SurveyUtils from "../../utils/SurveyUtils";
import { normalizeQuillLists } from "../../utils/ObjectUtils";
import { parseSurveyDate } from "../../utils/SurveyDateUtils";

export default class PDFCreator {
  static fontsInitialized = false;
  static rotatedTextCache = new Map();
  static logoImage =
    "data:image/jpg;base64,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";

  static ensurePdfSetup() {
    if (!PDFCreator.fontsInitialized) {
      pdf.addVirtualFileSystem(pdfFonts);
      PDFCreator.fontsInitialized = true;
    }
  }

  static async yieldToBrowser() {
    return new Promise((resolve) => setTimeout(resolve, 0));
  }

  static sanitizeFileNamePart(value) {
    return String(value ?? "")
      // Windows forbids these characters, including ASCII control characters.
      // eslint-disable-next-line no-control-regex
      .replace(/[<>:"/\\|?*\x00-\x1f]/g, "-")
      .replace(/[. ]+$/g, "");
  }

  static buildAnswersMap(answers = []) {
    const map = new Map();
    for (const answer of answers) {
      map.set(answer.name, answer);
    }
    return map;
  }

  static buildGroupedRowAnswers(answer) {
    const byLabel = new Map();
    const byLabelAndCol = new Map();

    for (const item of answer?.answers || []) {
      const label = item.label || "";
      const colLabel = item.colLabel || "";
      const key = `${label}__${colLabel}`;

      if (!byLabel.has(label)) byLabel.set(label, []);
      byLabel.get(label).push(item);

      if (!byLabelAndCol.has(key)) byLabelAndCol.set(key, []);
      byLabelAndCol.get(key).push(item);
    }

    return { byLabel, byLabelAndCol };
  }

  static getPrintConfigTitles(printConfig) {
    const AA = [
      "Zusammenarbeit mit dem DAAD",
      "Resümee Lektorentätigkeit  und weitere Karriereplanung ",
      "Resümee Lektoratstätigkeit und weitere Karriereplanung",
      "Übergabe des Lektorats",
      "DAAD-Alumniarbeit",
      "Ergänzende Bemerkungen und Angaben",
      "Technischer Hinweis"
    ];

    const RUECK = [
      "Einleitung",
      "Zusammenarbeit mit dem DAAD",
      "DAAD-Alumniarbeit",
      "Resümee Lektorentätigkeit  und weitere Karriereplanung ",
      "Resümee Lektoratstätigkeit und weitere Karriereplanung",
      "Ergänzende Bemerkungen und Angaben",
      "Technischer Hinweis"
    ];

    return printConfig === "AA" ? AA : printConfig === "RUECK" ? RUECK : null;
  }

  static createContext(
    surveyTemplate,
    surveyName,
    fundingAreaName,
    programName,
    surveyLanguage,
    surveyResult,
    userName,
    buffer,
    employeeNumber
  ) {
    return {
      currentUser: userName || "",
      employeeNumber: surveyResult?.employeeNumber || employeeNumber || "",
      surveyName: surveyName || "",
      fundingAreaName: fundingAreaName?.name || "Alle Förderbereiche",
      programName: programName?.name || "Alle Programme",
      templateVersion: surveyTemplate?.version?.toString?.() || "",
      projectName: surveyResult?.projectName || "",
      projectForeignId: surveyResult?.projectForeignId || "",
      universityName: surveyResult?.universityName || "",
      reportingYear: surveyResult?.reportingYear || "",
      editedOn: surveyResult?.lastEdited || "",
      submittedOn: surveyResult?.lastSubmitted || "",
      status: surveyResult?.status || "",
      translations: surveyLanguage ? PDFCreator.getTranslations(surveyLanguage.id) : PDFCreator.getTranslations("de"),
      buffer: !!buffer
    };
  }

  static async createPDFForGivenTemplates(surveySubmissions, templates, printConfig) {
    PDFCreator.ensurePdfSetup();
    const normalize = (str) => str?.replace(/\s+/g, "").toLowerCase();
    const zip = new JSZip();
    const excludedTitles = PDFCreator.getPrintConfigTitles(printConfig)?.map(normalize);
    const results = surveySubmissions?.results || [];

    for (const submission of results) {
      const survey = PDFCreator.getTemplateForSubmission(
        submission.reportPeriodGid,
        surveySubmissions,
        templates
      );

      if (!survey?.surveyTemplate) {
        continue;
      }

      const { title, buffer } = await PDFCreator.createPDFBufferForTemplate(
        survey.surveyTemplate,
        survey.surveyName,
        survey.fundingArea,
        survey.program,
        survey.language,
        submission,
        survey.updatedBy,
        excludedTitles
      );

      zip.file(`${title}.pdf`, buffer, { binary: true });

      await PDFCreator.yieldToBrowser();
    }

    const content = await zip.generateAsync({ type: "blob" });
    FileSaver.saveAs(content, "Berichte.zip");
  }

  static createPDFBufferForTemplate(
    surveyTemplate,
    surveyName,
    fundingAreaName,
    programName,
    surveyLanguage,
    surveyResult,
    userName,
    printConfig
  ) {
    return new Promise((resolve, reject) => {
      try {
        PDFCreator.ensurePdfSetup();

        const context = PDFCreator.createContext(
          surveyTemplate,
          surveyName,
          fundingAreaName,
          programName,
          surveyLanguage,
          surveyResult,
          userName,
          true
        );

        const dd = PDFCreator.buildDocumentDefinition(
          context,
          surveyTemplate,
          surveyResult,
          printConfig
        );

        const title = PDFCreator.sanitizeFileNamePart([
          surveyResult.projectForeignId,
          surveyResult.projectName,
          context.reportingYear,
          context.surveyName
        ].join("_"));

        pdf.createPdf(dd).getBuffer((convertedPdf) => {
          resolve({
            title,
            buffer: new Uint8Array(convertedPdf)
          });
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  static createPDFForGivenTemplate(
    surveyTemplate,
    surveyName,
    fundingAreaName,
    programName,
    surveyLanguage,
    surveyResult,
    buffer,
    pdfCallBack,
    userName,
    printConfig,
    employeeNumber
  ) {
    PDFCreator.ensurePdfSetup();

    const context = PDFCreator.createContext(
      surveyTemplate,
      surveyName,
      fundingAreaName,
      programName,
      surveyLanguage,
      surveyResult,
      userName,
      buffer,
      employeeNumber
    );

    const dd = PDFCreator.buildDocumentDefinition(
      context,
      surveyTemplate,
      surveyResult,
      printConfig
    );

    if (typeof buffer === "boolean" && buffer && typeof pdfCallBack === "function") {
      pdf.createPdf(dd).getBuffer((convertedPdf) => {
        pdfCallBack(new Uint8Array(convertedPdf));
      });
      return;
    }

    const title = context.projectName
      ? `${context.surveyName} '${PDFCreator.getProjectNameWithForeignId(context)}' ${PDFCreator.getDate(context)}`
      : `${context.surveyName} v${context.templateVersion} ${PDFCreator.getDate(context)}`;
    pdf.createPdf(dd).download(`${PDFCreator.sanitizeFileNamePart(title)}.pdf`);
  }

  static buildDocumentDefinition(context, surveyTemplate, surveyResult, printConfig) {
    const docDefinition = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [40, 80, 40, 40]
    };
    const normalize = (str) => str?.replace(/\s+/g, "").toLowerCase();
    return {
      header() {
        return [
          {
            columns: [
              {
                image: "logoImage",
                width: 180,
                margin: [20, 15, 0, 0]
              },
              {
                margin: [40, 20],
                text: " "
              }
            ]
          }
        ];
      },

      footer(currentPage, pageCount) {
        const dateString = PDFCreator.getDate(context);
        const pageString = currentPage.toString();
        const pagesString = pageCount.toString();

        if (pageString !== "1") {
          const middleText = context.surveyName || " ";
          return {
            columns: [
              {
                width: "auto",
                text: [context.translations.printDate + " ", { text: dateString }]
              },
              {
                width: "*",
                alignment: "center",
                text: middleText,
                fontsize: 9
              },
              {
                width: "auto",
                alignment: "right",
                text: [
                  context.translations.page + " ",
                  { text: pageString },
                  " " + context.translations.pageOf + " ",
                  { text: pagesString }
                ]
              }
            ],
            margin: [40, 10]
          };
        }

        return null;
      },

      content: [
        PDFCreator.buildFirstPage(context),
        printConfig
          ? PDFCreator.buildPages(
              context,
              surveyTemplate.pages.filter((template) => !printConfig.includes(normalize(template.title))),
              surveyResult.questions
            )
          : PDFCreator.buildPages(context, surveyTemplate.pages, surveyResult.questions)
      ],

      pageSize: docDefinition.pageSize,
      pageOrientation: docDefinition.pageOrientation,
      pageMargins: docDefinition.pageMargins,

      images: {
        logoImage: PDFCreator.logoImage
      },

      styles: {
        title: {
          fontSize: 24,
          bold: true,
          alignment: "center",
          margin: [0, 100, 0, 50]
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        infoheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 5]
        },
        subheader: {
          fontSize: 14,
          bold: true,
          margin: [0, 20, 0, 5]
        },
        text: {
          fontSize: 9
        },
        infoText: {
          fontSize: 9,
          italics: false,
          margin: [0, 5, 0, 10],
          color: "#666666"
        },
        selectBoxText: {
          fontSize: 9,
          italics: true,
          color: "#999999"
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 11,
          color: "white",
          fillColor: "#0060AF"
        },
        tableHeaderSmall: {
          bold: false,
          fontSize: 8,
          color: "white",
          fillColor: "#0060AF"
        },
        tableHeaderVerySmall: {
          bold: false,
          fontSize: 6,
          color: "white",
          fillColor: "#0060AF"
        },
        tableHeaderImage: {
          fillColor: "#0060AF"
        },
        inputFields: {
          bold: false,
          fontSize: 11,
          color: "black",
          fillColor: "#E6F0F0"
        }
      },

      defaultStyle: {
        fontSize: 11
      }
    };
  }

  static getTemplateForSubmission(reportPeriodGid, surveySubmissions, templates) {
    const templatesMap = surveySubmissions.templates;
    let template = {};

    Object.keys(templatesMap).forEach((key) => {
      if (templatesMap[key].includes(reportPeriodGid)) {
        const id = key.substring(1, key.length - 1);
        template = templates[id];
      }
    });

    return template;
  }

  static getProgram(context) {
    return `${context.fundingAreaName} / ${context.programName}`;
  }

  static getTemplateName(context) {
    return `${context.translations.template}: ${context.surveyName}`;
  }

  static getTemplateVersion(context) {
    return `Version: ${context.templateVersion}`;
  }

  static getProjectNameWithForeignId(context) {
    return `${context.projectForeignId} ${context.projectName}`;
  }

  static getForeignId(context) {
    return `${context.translations.projectNo}: ${context.projectForeignId}`;
  }

  static getLocationId(context) {
    return `${context.translations.locationNo}: ${context.projectForeignId}`;
  }

  static getEmployeeNumber(context) {
    return `${context.translations.employeeNumber}: ${context.employeeNumber}`;
  }

  static getCreationDate(context) {
    return `${context.translations.createdOn}: ${PDFCreator.getDate(context)}`;
  }

  static getEditedDate(context) {
    return `${context.translations.editedOn}: ${context.editedOn}`;
  }

  static getSubmissionDate(context) {
    const submissionDate = context.submittedOn
      ? context.submittedOn
      : context.buffer
      ? new Intl.DateTimeFormat("de-DE", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        }).format(new Date())
      : "";

    return `${context.translations.submittedOn}: ${submissionDate}`;
  }

  static getStatus(context) {
    const status =
      context.status === "SENT" || context.buffer
        ? context.translations.sent
        : context.status === "IN_PROGRESS"
        ? context.translations.progress
        : context.translations.new;

    return `${context.translations.status}: ${status}`;
  }

  static getCreationUser(context) {
    return `${context.translations.createdBy}: ${context.currentUser}`;
  }

  static getReportingYear(context) {
    return `${context.translations.reportingYear}: ${context.reportingYear}`;
  }

  static getAcedemicYear(context) {
    return (
      `${context.translations.reportingYearSemester}: ` +
      context.translations.semester
        .concat(" ")
        .concat(context.reportingYear)
        .concat("/")
        .concat(String(Number(context.reportingYear) + 1).slice(-2))
    );
  }

  static buildFirstPage(context) {
    const body = [];

    if (context.projectName) {
      body.push({
        text: context.projectName,
        style: "title"
      });

      body.push({
        text: SurveyUtils.isSemesterTypeProgram(context.programName)
          ? PDFCreator.getLocationId(context)
          : PDFCreator.getForeignId(context),
        style: "subheader",
        alignment: "center"
      });

      if (SurveyUtils.isSemesterTypeProgram(context.programName) && context.employeeNumber) {
        body.push({
          text: PDFCreator.getEmployeeNumber(context),
          style: "subheader",
          alignment: "center"
        });
      }

      if (context.universityName && !SurveyUtils.isSemesterTypeProgram(context.programName)) {
        body.push({
          text: context.universityName,
          style: "subheader",
          alignment: "center"
        });
      }

      if (SurveyUtils.isSemesterTypeProgram(context.programName)) {
        body.push({
          text: PDFCreator.getTemplateName(context),
          style: "subheader",
          alignment: "center"
        });
      }

      body.push({
        text: SurveyUtils.isSemesterTypeProgram(context.programName)
          ? PDFCreator.getAcedemicYear(context)
          : PDFCreator.getReportingYear(context),
        style: "subheader",
        alignment: "center"
      });

      body.push({
        text: PDFCreator.getStatus(context),
        style: "subheader",
        alignment: "center"
      });

      if (context.status === "SENT" || context.buffer) {
        body.push({
          text: PDFCreator.getSubmissionDate(context),
          style: "subheader",
          alignment: "center"
        });
      } else if (context.status === "IN_PROGRESS") {
        body.push({
          text: PDFCreator.getEditedDate(context),
          style: "subheader",
          alignment: "center"
        });
      } else {
        body.push({
          text: PDFCreator.getCreationDate(context),
          style: "subheader",
          alignment: "center"
        });
      }
    } else {
      body.push({
        text: PDFCreator.getTemplateName(context),
        style: "title"
      });
      body.push({
        text: PDFCreator.getTemplateVersion(context),
        style: "subheader",
        alignment: "center"
      });
      body.push({
        text: PDFCreator.getProgram(context),
        style: "subheader",
        alignment: "center"
      });
      body.push({
        text: PDFCreator.getCreationDate(context),
        style: "subheader",
        alignment: "center"
      });
    }

    return body;
  }

  static buildPages(context, templatePages, answers) {
    const body = [];
    const answersMap = PDFCreator.buildAnswersMap(answers);

    templatePages.forEach((templatePage) => {
      if (context.projectName && !templatePage.visible) {
        let isPageVisible = false;

        for (const question of templatePage.questions) {
          const questionAnswer = answersMap.get(question.name);
          if (questionAnswer?.answers?.length > 0) {
            isPageVisible = true;
            break;
          }
        }

        if (!isPageVisible) {
          return;
        }
      }

      const pageTitle = templatePage.title || templatePage.name;
      body.push({
        text: pageTitle,
        style: "header",
        pageBreak: "before"
      });

      templatePage.questions.forEach((question) => {
        const mandatory = question.isRequired ? " *" : "";
        const questionAnswer = answersMap.get(question.name);

        if (
          context.projectName &&
          !question.visible &&
          (!questionAnswer || !questionAnswer.answers || questionAnswer.answers.length === 0)
        ) {
          return;
        }

        const questionStack = [];
        const suffix = question.suffix || " ";

        if (question.type === "infoMessage") {
          questionStack.push({
            stack: PDFCreator.html2pdfmake(question.title),
            style: "infoheader",
            headlineLevel: 1
          });
        } else if (question.type === "projectData") {
          questionStack.push({
            text: context.translations.projectInformation,
            style: "infoheader",
            headlineLevel: 1
          });
        } else {
          questionStack.push({
            columns: [
              {
                width: "auto",
                stack: PDFCreator.html2pdfmake(question.title),
                style: "subheader",
                headlineLevel: 1
              },
              ...(mandatory
                ? [
                    {
                      width: "auto",
                      text: mandatory.trim(),
                      style: "subheader"
                    }
                  ]
                : [])
            ],
            columnGap: 2
          });
        }

        if (question.description && question.description.length > 1) {
          questionStack.push({
            stack: PDFCreator.html2pdfmake(question.description),
            style: "infoText",
            headlineLevel: 1
          });
        }

        if (context.projectName && questionAnswer) {
          PDFCreator.getQuestionAnswer(context, question, questionAnswer, questionStack);
        } else {
          if (question.type === "projectData") {
            PDFCreator.buildStaticProjectDataTable(context, questionStack);
          } else if (question.type === "staticTable" || question.type === "dynamicTable") {
            questionStack.push(PDFCreator.buildTable(context, question, question.type === "staticTable"));
          } else if (question.type === "comment") {
            questionStack.push({
              style: "inputFields",
              layout: "noBorders",
              table: {
                widths: "80%",
                body: [[" "]]
              }
            });
          } else if (question.type === "text" || question.type === "number" || question.type === "date") {
            questionStack.push({
              style: "inputFields",
              layout: "noBorders",
              table: {
                widths: "20%",
                body: [
                  [
                    {
                      text: suffix,
                      alignment: "right"
                    }
                  ]
                ]
              }
            });
          } else if (question.type === "matrixSingleChoice" || question.type === "matrixMultipleChoice") {
            questionStack.push(PDFCreator.buildMatrix(context, question, question.type === "matrixSingleChoice"));
          } else if (question.type === "radio" || question.type === "checkbox" || question.type === "predefinedList") {
            if (question.type === "predefinedList") {
              questionStack.push(PDFCreator.getPredefinedListTypeText(question.predefinedListType));
            } else {
              questionStack.push(PDFCreator.buildDropdown(context, question.choices, question.hasOther));
            }
          }
        }

        body.push({ stack: questionStack });
      });
    });

    return body;
  }

  static buildTable(context, question, staticTable) {
    return {
      table: {
        headerRows: 1,
        widths: PDFCreator.buildWidthArray(
          question.columns,
          staticTable,
          PDFCreator.hasStaticTableDescriptions(question.rows)
        ),
        body: PDFCreator.buildTableBody(context, question.columns, question.rows, staticTable)
      }
    };
  }

  static buildWidthArray(columns, staticTable, hasDescription) {
    let widthsArray;
    let columnCount = columns.length;

    if (columnCount < 8) {
      widthsArray = [];
      if (staticTable && hasDescription) {
        columnCount += 1;
      }

      const widthValue = 100 / columnCount;
      for (let c = 0; c < columnCount; c++) {
        widthsArray.push(widthValue + "%");
      }
    }

    return widthsArray;
  }

  static buildMatrix(context, question, singleChoice) {
    return {
      table: {
        headerRows: 1,
        body: PDFCreator.buildTableBody(context, question.choices, question.rows, singleChoice)
      }
    };
  }

  static buildTableBody(context, columns, rows, staticTable) {
    const tableBody = [];
    const columnRow = [];
    let tableHeaderStyle = "tableHeader";
    let veryBigTable = false;

    if (columns && columns.length > 15) {
      tableHeaderStyle = "tableHeaderImage";
      veryBigTable = true;
    } else if (columns && columns.length > 10) {
      tableHeaderStyle = "tableHeaderVerySmall";
    } else if (columns && columns.length > 7) {
      tableHeaderStyle = "tableHeaderSmall";
    }

    if (PDFCreator.hasTableColumnHeaders(columns)) {
      if (staticTable && PDFCreator.hasStaticTableDescriptions(rows)) {
        columnRow.push({
          text: " ",
          style: tableHeaderStyle
        });
      }

      columns.forEach((column) => {
        if (veryBigTable) {
          columnRow.push({
            image: PDFCreator.writeRotatedText(column.text),
            fit: [70, 100],
            style: tableHeaderStyle,
            alignment: "center"
          });
        } else {
          columnRow.push({
            text: column.text,
            style: tableHeaderStyle
          });
        }
      });

      tableBody.push(columnRow);
    }

    PDFCreator.buildTableRows(context, columns, rows, staticTable, tableBody);
    return tableBody;
  }

  static hasStaticTableDescriptions(rows) {
    let hasDescription = false;
    rows?.forEach((row) => {
      if (row.text && row.text.length > 0) {
        hasDescription = true;
      }
    });
    return hasDescription;
  }

  static hasTableColumnHeaders(columns) {
    let hasHeaders = false;
    columns?.forEach((column) => {
      if (column.text && column.text.length > 0) {
        hasHeaders = true;
      }
    });
    return hasHeaders;
  }

  static buildTableRows(context, columns, rows, staticTable, tableBody) {
    if (staticTable) {
      const hasDescription = PDFCreator.hasStaticTableDescriptions(rows);
      rows.forEach((row) => {
        const dataRow = [];
        if (hasDescription) {
          dataRow.push({
            text: row.text,
            style: "tableHeader"
          });
        }
        tableBody.push(PDFCreator.addTableRow(context, columns, dataRow));
      });
    } else {
      tableBody.push(PDFCreator.addTableRow(context, columns, []));
    }

    return tableBody;
  }

  static addTableRow(context, columns, dataRow) {
    columns.forEach((column) => {
      if (PDFCreator.isSelectionColumn(column) && columns.length < 13 && column.choices) {
        dataRow.push(PDFCreator.buildDropdown(context, column.choices, column.hasOther));
      } else if (column.type === "predefinedList" && columns.length < 13) {
        dataRow.push({
          text: "<" + PDFCreator.getPredefinedListTypeText(column.predefinedListType) + ">",
          style: "selectBoxText"
        });
      } else {
        dataRow.push(" ");
      }
    });

    return dataRow;
  }

  static isSelectionColumn(column) {
    return column.type === "Dropdown" || column.type === "Radio" || column.type === "Checkbox";
  }

  static getPredefinedListTypeText(predefinedListType) {
    let pL_name = predefinedListType || "predefinedList";

    if (pL_name === "study_categories" || pL_name === "FIELD_OF_STUDY" || pL_name === "STUDY_CATEGORIES") {
      pL_name = "Fächergruppe";
    }
    if (pL_name === "study_degrees" || pL_name === "SUBJECT_OF_STUDY" || pL_name === "STUDY_DEGREES") {
      pL_name = "Studienfach";
    }
    if (pL_name === "regions" || pL_name === "REGIONS") {
      pL_name = "Regionen";
    }
    if (pL_name === "countries" || pL_name === "COUNTRIES") {
      pL_name = "Länder";
    }

    return pL_name;
  }

  static buildDropdown(context, choices, hasOther) {
    const listItems = [];
    let hasChoiceText = false;

    choices.forEach((choice) => {
      if (choice.text && choice.text.length > 0) {
        listItems.push({
          text: choice.text,
          style: "selectBoxText"
        });
        hasChoiceText = true;
      }
    });

    if (hasOther) {
      listItems.push({
        text: context.translations.others,
        style: "selectBoxText"
      });
      hasChoiceText = true;
    }

    if (hasChoiceText) {
      return {
        ul: listItems,
        alignment: "left"
      };
    }

    return " ";
  }

  static buildStaticProjectDataTable(context, questionStack, answer) {
    const tableRows = ["project", "university", "faculty", "fundingBegin", "fundingEnd", "reportingYear"];
    const tableBody = [];

    tableRows.forEach((tableRow) => {
      let value = " ";

      switch (tableRow) {
        case "project": {
          let projectName = " ";
          let projectNo = " ";

          if (answer?.answers) {
            answer.answers.forEach((answerObj) => {
              if (answerObj.name === tableRow) {
                projectName = answerObj.text;
                projectNo = answerObj.value;
              }
            });
          }

          tableBody.push([
            { text: context.translations.projectName, style: "tableHeader" },
            projectName
          ]);
          tableBody.push([
            { text: context.translations.projectNo, style: "tableHeader" },
            projectNo
          ]);
          break;
        }

        case "fundingBegin":
          if (answer?.answers) {
            answer.answers.forEach((answerObj) => {
              if (answerObj.name === tableRow) value = answerObj.text;
            });
          }
          tableBody.push([
            { text: context.translations.firstFundingYear, style: "tableHeader" },
            value
          ]);
          break;

        case "fundingEnd":
          if (answer?.answers) {
            answer.answers.forEach((answerObj) => {
              if (answerObj.name === tableRow) value = answerObj.text;
            });
          }
          tableBody.push([
            { text: context.translations.lastFundingYear, style: "tableHeader" },
            value
          ]);
          break;

        case "reportingYear":
          if (answer?.answers) {
            answer.answers.forEach((answerObj) => {
              if (answerObj.name === tableRow) value = answerObj.text;
            });
          }
          tableBody.push([
            { text: context.translations.reportingYear, style: "tableHeader" },
            value
          ]);
          break;

        case "university":
          if (answer?.answers) {
            answer.answers.forEach((answerObj) => {
              if (answerObj.name === tableRow) value = answerObj.text;
            });
          }
          tableBody.push([
            { text: context.translations.university, style: "tableHeader" },
            value
          ]);
          break;

        case "faculty":
          if (answer?.answers) {
            answer.answers.forEach((answerObj) => {
              if (answerObj.name === tableRow) value = answerObj.text;
            });
          }
          tableBody.push([
            { text: context.translations.faculty, style: "tableHeader" },
            value
          ]);
          break;

        default:
          tableBody.push([{ text: " ", style: "tableHeader" }, " "]);
      }
    });

    questionStack.push({
      table: {
        widths: ["30%", "*"],
        body: tableBody
      }
    });
  }

  static getQuestionAnswer(context, question, answers, questionStack) {
    if (question.type === "number" || question.type === "text" || question.type === "comment" || question.type === "date") {
      PDFCreator.buildSimpleAnswers(context, question, answers, questionStack);
    } else if (question.type === "projectData") {
      PDFCreator.buildStaticProjectDataTable(context, questionStack, answers);
    } else if (
      question.type === "radio" ||
      question.type === "checkbox" ||
      question.type === "dropdown" ||
      question.type === "predefinedList"
    ) {
      PDFCreator.getSelectedAnswers(answers, questionStack);
    } else if (question.type === "dynamicTable" || question.type === "staticTable") {
      if (answers.rows && answers.rows.length > 0) {
        PDFCreator.getAnswerTable(context, question, answers, questionStack);
      } else {
        questionStack.push(PDFCreator.buildTable(context, question, question.type === "staticTable"));
      }
    } else if (question.type === "matrixSingleChoice" || question.type === "matrixMultipleChoice") {
      if (answers.rows && answers.rows.length > 0) {
        PDFCreator.getAnswerMatrix(context, question, answers, questionStack);
      } else {
        questionStack.push(PDFCreator.buildMatrix(context, question, question.type === "matrixSingleChoice"));
      }
    }
  }

  static buildSimpleAnswers(context, question, answer, questionStack) {
    const suffix = question.suffix || " ";
    let answerText = "";
    let tableWidth = "auto";

    if (answer.answers && answer.answers[0] && answer.answers[0].value) {
      const answerObj = answer.answers[0];

      if (question.type === "date") {
        answerText = {
          text: PDFCreator.getDate(context, answerObj.value, question.dateFormat) + " " + suffix,
          alignment: "left",
          margin: [5, 0, 5, 0]
        };
      } else if (question.type === "number") {
        answerText = {
          text: PDFCreator.getNumber(answerObj.value) + " " + suffix,
          alignment: "right",
          margin: [5, 0, 5, 0]
        };
      } else if (question.type === "comment") {
        answerText = {
          stack: PDFCreator.html2pdfmake(answerObj.value),
          alignment: "left",
          margin: [5, 0, 5, 0]
        };
      } else {
        answerText = {
          text: PDFCreator.handleHTMLText(answerObj.value) + " " + suffix,
          alignment: "left",
          margin: [5, 0, 5, 0]
        };
      }
    } else {
      answerText = {
        text: suffix,
        alignment: "right",
        margin: [5, 0, 5, 0]
      };
      tableWidth = "20%";
    }

    questionStack.push({
      style: "inputFields",
      layout: "noBorders",
      table: {
        widths: tableWidth,
        body: [[answerText]]
      }
    });
  }

  static getSelectedAnswers(answer, questionStack) {
    const listItems = [];
    let hasChoiceText = false;
    const choices = answer.answers;

    choices.forEach((choice) => {
      if (choice.text && choice.text.length > 0) {
        listItems.push({
          text: choice.text,
          style: "inputFields"
        });
        hasChoiceText = true;
      } else if (choice.value && choice.value.length > 0) {
        listItems.push({
          text: choice.value,
          style: "inputFields"
        });
        hasChoiceText = true;
      }
    });

    if (hasChoiceText) {
      questionStack.push({
        style: "inputFields",
        layout: "noBorders",
        table: {
          widths: "auto",
          body: [
            [
              {
                ul: listItems,
                alignment: "left",
                style: "inputFields",
                margin: [5, 0]
              }
            ]
          ]
        }
      });
    } else {
      questionStack.push({
        style: "inputFields",
        layout: "noBorders",
        table: {
          widths: "20%",
          body: [[" "]]
        }
      });
    }
  }

  static getAnswerTable(context, question, answer, questionStack) {
    const groupedAnswers = PDFCreator.buildGroupedRowAnswers(answer);
    const tableBody = PDFCreator.buildAnswerTableBody(context, question, answer, groupedAnswers);

    questionStack.push({
      table: {
        headerRows: 1,
        widths: "auto",
        body: tableBody
      },
      layout: {
        paddingLeft: () => 1,
        paddingRight: () => 1,
        paddingTop: () => 0,
        paddingBottom: () => 0,
        vLineWidth: () => 0.5,
        hLineWidth: () => 0.5
      }
    });
  }

  static getAnswerMatrix(context, question, answer, questionStack) {
    const groupedAnswers = PDFCreator.buildGroupedRowAnswers(answer);

    questionStack.push({
      table: {
        headerRows: 1,
        body: PDFCreator.buildAnswerTableBody(context, question, answer, groupedAnswers)
      }
    });
  }

  static writeRotatedText(text) {
    if (!text) return "";

    if (PDFCreator.rotatedTextCache.has(text)) {
      return PDFCreator.rotatedTextCache.get(text);
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = 64;
    canvas.height = 500;

    ctx.fillStyle = "#0060AF";
    ctx.fillRect(0, 0, 64, 500);
    ctx.font = "28pt Arial";
    ctx.save();
    ctx.translate(32, 500);
    ctx.rotate(-0.5 * Math.PI);
    ctx.fillStyle = "white";

    const wrappedText = PDFCreator.wrapText(ctx, text, 0, 0, 500, 32);
    wrappedText.forEach((item) => {
      ctx.fillText(item[0], item[1], item[2]);
    });

    ctx.restore();

    const dataUrl = canvas.toDataURL();
    PDFCreator.rotatedTextCache.set(text, dataUrl);
    return dataUrl;
  }

  static wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    let testLine = "";
    const lineArray = [];

    for (let n = 0; n < words.length; n++) {
      testLine += `${words[n]} `;
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;

      if (testWidth > maxWidth && n > 0) {
        lineArray.push([line, x, y]);
        y += lineHeight;
        line = `${words[n]} `;
        testLine = `${words[n]} `;
      } else {
        line += `${words[n]} `;
      }

      if (n === words.length - 1) {
        lineArray.push([line, x, y]);
      }
    }

    return lineArray;
  }

  static buildAnswerTableBody(context, question, answer, groupedAnswers) {
    const staticTable = question.type !== "dynamicTable";
    const rows = question.rows;
    let columns = question.columns;
    let tableHeaderStyle = "tableHeader";
    let veryBigTable = false;

    if (question.type === "matrixSingleChoice" || question.type === "matrixMultipleChoice") {
      columns = question.choices;
    } else if (columns && columns.length > 12) {
      tableHeaderStyle = "tableHeaderImage";
      veryBigTable = true;
    } else if (columns && columns.length > 8) {
      tableHeaderStyle = "tableHeaderVerySmall";
    } else if (columns && columns.length > 5) {
      tableHeaderStyle = "tableHeaderSmall";
    }

    const tableBody = [];
    const columnRow = [];

    if (PDFCreator.hasTableColumnHeaders(columns)) {
      if (staticTable && PDFCreator.hasStaticTableDescriptions(rows)) {
        columnRow.push({
          text: " ",
          style: tableHeaderStyle
        });
      }

      columns.forEach((column) => {
        if (veryBigTable) {
          columnRow.push({
            image: PDFCreator.writeRotatedText(column.text),
            fit: [70, 100],
            style: tableHeaderStyle,
            alignment: "center"
          });
        } else {
          columnRow.push({
            text: column.text,
            style: tableHeaderStyle
          });
        }
      });

      tableBody.push(columnRow);
    }

    PDFCreator.buildAnswerTableRows(context, question, answer, staticTable, tableBody, groupedAnswers);
    return tableBody;
  }

  static buildAnswerTableRows(context, question, answer, staticTable, tableBody, groupedAnswers) {
    const rows = answer.rows;

    if (staticTable) {
      const questionRows = question.rows;
      questionRows.forEach((questionRow) => {
        const dataRow = [];

        if (PDFCreator.hasStaticTableDescriptions(questionRows)) {
          dataRow.push({
            text: questionRow.text,
            style: "tableHeader"
          });
        }

        const rowAnswers = groupedAnswers.byLabel.get(questionRow.name) || [];
        tableBody.push(
          PDFCreator.addAnswerTableRow(context, question, rowAnswers, dataRow, groupedAnswers)
        );
      });
    } else {
      rows.forEach((row) => {
        const rowAnswers = groupedAnswers.byLabel.get(row.name) || [];
        tableBody.push(
          PDFCreator.addAnswerTableRow(context, question, rowAnswers, [], groupedAnswers)
        );
      });
    }

    return tableBody;
  }

  static addAnswerTableRow(context, question, rowAnswers, dataRow, groupedAnswers) {
    let columns = question.columns;

    if (question.type === "matrixSingleChoice" || question.type === "matrixMultipleChoice") {
      columns = question.choices;

      columns.forEach((column) => {
        const answerStack = [];
        rowAnswers.forEach((cellAnswer) => {
          if (cellAnswer.value === column.value) {
            answerStack.push("X");
          }
        });
        dataRow.push({ stack: answerStack });
      });

      return dataRow;
    }

    let cellStyle = { fontSize: "11" };

    if (columns.length > 12) {
      cellStyle = { fontSize: "5", margin: [0, 0, 0, 0] };
    } else if (columns.length > 8) {
      cellStyle = { fontSize: "6", margin: [0, 0, 0, 0] };
    } else if (columns.length > 5) {
      cellStyle = { fontSize: "8" };
    }

    columns.forEach((column) => {
      const isActivityMonitoring =
        context.fundingAreaName === "Aktivitätenmonitoring" &&
        question.title.includes("Aktivitäten 20") &&
        column.choices &&
        column.choices.length > 0;

      const choiceValues = [];

      if (isActivityMonitoring) {
        column.choices.forEach((choice) => {
          const value = choice.infoText ? choice.infoText : choice.text.split(":")[0];
          choiceValues.push({
            choice: choice.value,
            value
          });
        });
      }

      const suffix = column.suffix || "";
      const answerStack = [];
      const keyMatches = rowAnswers.filter((rowAnswer) => rowAnswer.colLabel === column.value);

      keyMatches.forEach((cellAnswer) => {
        if (column.type === "Date") {
          answerStack.push(PDFCreator.getDate(context, cellAnswer.value, question.dateFormat));
        } else if (column.type === "Number") {
          answerStack.push({
            text: PDFCreator.getNumber(cellAnswer.text) + " " + suffix,
            alignment: "right"
          });
        } else if (column.type === "Text") {
          answerStack.push({
            stack: PDFCreator.html2pdfmake(cellAnswer.value)
          });
        } else if (isActivityMonitoring) {
          const answerValue = choiceValues.find((element) => element.choice === cellAnswer.value);
          answerStack.push(answerValue ? answerValue.value : cellAnswer.value + " " + suffix);
        } else if (
          PDFCreator.isSelectionColumn(column) &&
          (!cellAnswer.text || "Option-0" === cellAnswer.text?.trim()) &&
          "Option-0" === cellAnswer.value?.trim()
        ) {
          answerStack.push(`X ${suffix}`);
        } else if (cellAnswer.text && cellAnswer.text.length > 0) {
          answerStack.push(cellAnswer.text + " " + suffix);
        } else if (cellAnswer.value && cellAnswer.value.length > 0) {
          answerStack.push(cellAnswer.value + " " + suffix);
        } else {
          answerStack.push(" ");
        }
      });

      dataRow.push({
        stack: answerStack,
        ...cellStyle
      });
    });

    return dataRow;
  }

  static getDate(context, date, dateFormat) {
    const today = date ? parseSurveyDate(date) : moment.utc();
    if (!today.isValid()) return String(date);

    if (context?.translations?.language === "de") {
      const dateType =
        dateFormat === "Day" ? "DD.MM.YYYY" :
        dateFormat === "Month" ? "MM/YYYY" :
        dateFormat === "Year" ? "YYYY" :
        "DD.MM.YYYY";

      return today.format(dateType);
    }

    const dateType =
      dateFormat === "Day" ? "DD/MM/YYYY" :
      dateFormat === "Month" ? "MM/YYYY" :
      dateFormat === "Year" ? "YYYY" :
      "DD/MM/YYYY";

    return today.format(dateType);
  }

  static getNumber(number) {
    return number;
  }

  static handleHTMLText(text) {
    let stripped = text && text.length ? text : "";
    stripped = stripped.replace(/<br>/g, "\n");
    stripped = stripped.replace(/<br\/>/g, "\n");
    stripped = stripped.replace(/<li>/g, "· ");
    stripped = stripped.replace(/<\/?[a-zA-Z ]+\/?>/gi, "");
    stripped = stripped.replace(/&[a-zA-Z]+;/gi, "");
    return stripped;
  }

  static getTranslations(languageKey) {
    return languageKey === "de"
      ? {
          language: "de",
          projectInformation: "Informationen zum Projekt",
          projectName: "Projektbezeichnung",
          projectNo: "Projekt-ID",
          locationNo: "Standort-ID",
          employeeNumber: "PKZ",
          amount: "Höhe der Gesamtzuwendung",
          firstFundingYear: "Förderbeginn",
          lastFundingYear: "Förderende",
          numberOfFundingYear: "Anzahl der Förderjahre",
          reportingYear: "Berichtsjahr (entspricht Haushaltsjahr)",
          reportingYearSemester: "Berichtszeitraum",
          semester: "Hochschuljahr",
          university: "Zuwendungsempfänger",
          faculty: "Organisationsbereich",
          printDate: "Datum PDF Download",
          page: "Seite",
          pageOf: "von",
          template: "Vorlage",
          date: "Datum",
          createdOn: "Stand vom",
          editedOn: "Letzte Bearbeitung am",
          submittedOn: "Eingereicht am",
          status: "Bearbeitungsstatus",
          sent: "Eingereicht",
          progress: "In Bearbeitung",
          new: "Neu",
          createdBy: "Erstellt von",
          questionsAnswered: "Beantwortete Fragen",
          requiredQuestions: "davon Pflichtfragen",
          others: "Sonstiges"
        }
      : {
          language: "en",
          projectInformation: "Project information",
          projectName: "Project name",
          projectNo: "Project ID",
          locationNo: "Location ID",
          employeeNumber: "Identifier",
          amount: "Total amount of funding",
          firstFundingYear: "Funding begin",
          lastFundingYear: "Funding end",
          numberOfFundingYear: "Number of funding years",
          reportingYear: "Reporting year (equivalent to fiscal year)",
          reportingYearSemester: "Reporting period",
          semester: "Academic year",
          university: "Grantee",
          faculty: "Faculty",
          printDate: "Date PDF download",
          page: "Page",
          pageOf: "of",
          template: "Template",
          date: "Date",
          createdOn: "Updated on",
          editedOn: "Last edited on",
          submittedOn: "Submitted on",
          status: "Status of report",
          sent: "Submitted",
          progress: "In progress",
          new: "New",
          createdBy: "Created by",
          questionsAnswered: "Answered questions",
          requiredQuestions: "thereof compulsory",
          others: "Other"
        };
  }

  static html2pdfmake(html) {
    const content = [];
    ParseHtml(content, normalizeQuillLists(html));
    return content;

    function ParseContainer(cnt, e, p, styles) {
      const elements = [];
      const children = e.childNodes;

      if (children.length !== 0) {
        for (let i = 0; i < children.length; i++) {
          p = ParseElement(elements, children[i], p, styles);
        }
      }

      if (elements.length !== 0) {
        for (let i = 0; i < elements.length; i++) {
          cnt.push(elements[i]);
        }
      }

      return p;
    }

    function ComputeStyle(o, styles) {
      for (let i = 0; i < styles.length; i++) {
        let st = styles[i].trim().toLowerCase().split(":");
        if (st.length === 2) {
          st[0] = st[0].trim();
          st[1] = st[1].trim();

          if (st[0] === "font-size") {
            o.fontSize = parseInt(st[1], 10);
          } else if (st[0] === "text-align") {
            if (st[1] === "right") o.alignment = "right";
            else if (st[1] === "center") o.alignment = "center";
          } else if (st[0] === "font-weight") {
            if (st[1] === "bold") o.bold = true;
          } else if (st[0] === "text-decoration") {
            if (st[1] === "underline") o.decoration = "underline";
          } else if (st[0] === "font-style") {
            if (st[1] === "italic") o.italics = true;
          }
        }
      }
    }

    function ParseElement(cnt, e, p, styles) {
      styles = styles || [];

      if (e.getAttribute) {
        const nodeStyle = e.getAttribute("style");
        if (nodeStyle) {
          const ns = nodeStyle.split(";");
          for (let k = 0; k < ns.length; k++) {
            styles.push(ns[k]);
          }
        }
      }

      let item;

      switch (e.nodeName.toLowerCase()) {
        case "#text":
          item = { text: e.textContent };
          if (styles) ComputeStyle(item, styles);
          p.text.push(item);
          break;

        case "b":
        case "strong":
          ParseContainer(cnt, e, p, styles.concat(["font-weight:bold"]));
          break;

        case "u":
          ParseContainer(cnt, e, p, styles.concat(["text-decoration:underline"]));
          break;

        case "i":
        case "em":
          ParseContainer(cnt, e, p, styles.concat(["font-style:italic"]));
          break;

        case "span":
          ParseContainer(cnt, e, p, styles);
          break;

        case "br":
          p = CreateParagraph();
          p.text.push("\n");
          cnt.push(p);
          break;

        case "table":
          item = {
            table: {
              widths: [],
              body: []
            }
          };

          {
            const border = e.getAttribute("pdf-border");
            const layouts = ["noBorders", "headerLineOnly", "lightHorizontalLines"];
            if (layouts.indexOf(border) > -1) {
              item.layout = border;
            }
          }

          ParseContainer(item.table.body, e, p, styles);

          {
            const widths = e.getAttribute("pdf-widths");
            if (!widths) {
              if (item.table.body.length !== 0 && item.table.body[0].length !== 0) {
                for (let k = 0; k < item.table.body[0].length; k++) {
                  item.table.widths.push("*");
                }
              }
            } else {
              const w = widths.split(/[\s,]+/);
              for (let k = 0; k < w.length; k++) {
                item.table.widths.push(w[k]);
              }
            }
          }

          cnt.push(item);
          break;

        case "tbody":
          ParseContainer(cnt, e, p, styles);
          break;

        case "tr": {
          const row = [];
          ParseContainer(row, e, p, styles);
          cnt.push(row);
          break;
        }

        case "td":
          p = CreateParagraph();
          item = { stack: [] };
          item.stack.push(p);

          {
            const rspan = e.getAttribute("rowspan");
            if (rspan) item.rowSpan = parseInt(rspan, 10);
          }

          {
            const cspan = e.getAttribute("colspan");
            if (cspan) item.colSpan = parseInt(cspan, 10);
          }

          ParseContainer(item.stack, e, p, styles);
          cnt.push(item);
          break;

        case "div":
        case "li":
        case "p":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          p = CreateParagraph();
          item = { stack: [] };
          item.stack.push(p);
          ComputeStyle(item, styles);
          ParseContainer(item.stack, e, p);
          cnt.push(item);
          break;

        case "ul":
          item = { ul: [] };
          ParseContainer(item.ul, e, p, styles);
          cnt.push(item);
          break;

        case "ol":
          item = { ol: [] };
          ParseContainer(item.ol, e, p, styles);
          cnt.push(item);
          break;

        default:
          console.log("#html2pdfmake", "Parsing for node " + e.nodeName + " not found");
          break;
      }

      return p;
    }

    function ParseHtml(cnt, htmlText) {
      htmlText = htmlText.replace(/<p><\/p>/g, "<p><br></p>");
      const p = CreateParagraph();
      const el = document.createElement("div");
      el.innerHTML = htmlText;
      ParseElement(cnt, el, p);
    }

    function CreateParagraph() {
      return { text: [] };
    }
  }
}
